(() => {
  'use strict';

  const TEMPLATE_ID = 'collection-mobile-sticky-toolbar-template';

  const testInfo = {
    className: 'sticky-head-filter',
  };

  function waitForElement(
    waitFor,
    callback,
    minElements = 1,
    isVariable = false,
    timer = 10000,
    frequency = 25,
  ) {
    const elements = isVariable ? window[waitFor] : document.querySelectorAll(waitFor);
    if (timer <= 0) return;
    if ((!isVariable && elements.length >= minElements) || (isVariable && typeof window[waitFor] !== 'undefined')) {
      callback(elements);
    } else {
      setTimeout(() => waitForElement(waitFor, callback, minElements, isVariable, timer - frequency, frequency), frequency);
    }
  }

  function cloneStickyFromTemplate() {
    const tpl = document.getElementById(TEMPLATE_ID);
    if (!tpl?.content) return false;
    document.body.appendChild(tpl.content.cloneNode(true));
    return true;
  }

  function handleScroll() {
    const topBar = document.querySelector('.collection.collection--filters-sidebar .collection__top-bar');
    const headerEl = document.querySelector('header');
    if (!topBar || !headerEl) return;

    const rect = topBar.getBoundingClientRect();
    const totalHeight = headerEl.offsetHeight;

    const isInViewport =
      rect.top >= totalHeight && rect.top <= (window.innerHeight || document.documentElement.clientHeight);

    if (window.innerWidth < 768) {
      if (isInViewport) {
        document.body.classList.remove('show-sticky');
      } else {
        document.body.classList.add('show-sticky');
      }
    } else {
      document.body.classList.remove('show-sticky');
    }
  }

  function setGMDStickyTop() {
    const sticky = document.querySelector('.head-sticky-section-wrapper');
    if (!sticky) return;

    let totalHeight = document.querySelector('header')?.offsetHeight ?? 0;

    sticky.setAttribute('style', `top: ${totalHeight}px;`);
  }

  function ctaTextUpdate() {
    const span = document.querySelector(
      '.collection.collection--filters-sidebar .collection__top-bar button.collection__top-filter span',
    );
    const labelSpan = document.querySelector('.head-sticky-section-wrapper #filter span');
    const countEl = document.querySelector('.head-sticky-section-wrapper #filter .head-sticky-count');

    if (span && labelSpan) {
      const fltCount = span.textContent.trim();
      if (!countEl) {
        labelSpan.insertAdjacentHTML('afterend', `<span class="head-sticky-count">${fltCount}</span>`);
      } else {
        countEl.textContent = fltCount;
      }
    } else if (countEl) {
      countEl.remove();
    }
  }

  if (!window.location.href.includes('search?q')) {
    waitForElement('.collection.collection--filters-sidebar .collection__top-bar button', () => {
      if (!document.getElementById(TEMPLATE_ID)) return;

      if (!document.querySelector('.head-sticky-section-wrapper')) {
        if (!cloneStickyFromTemplate()) return;

        setGMDStickyTop();

        const filterBtn = document.querySelector(
          '.collection.collection--filters-sidebar .collection__top-bar button.collection__top-filter',
        );
        if (filterBtn) {
          const filterTxt = filterBtn.textContent.replace(/[0-9]/g, '').trim();
          const stickyLabel = document.querySelector('.head-sticky-section-wrapper #filter span');
          if (stickyLabel) stickyLabel.textContent = filterTxt;
          ctaTextUpdate();
          document.querySelector('.head-sticky-section-wrapper #filter')?.addEventListener('click', () => {
            filterBtn.click();
          });
        }

        const sortLink = document.querySelector(
          '.collection.collection--filters-sidebar .collection__top-bar .facets-summary button .reversed-link',
        );
        if (sortLink) {
          document.querySelector('.head-sticky-section-wrapper #popover')?.addEventListener('click', () => {
            document
              .querySelector(
                '.collection.collection--filters-sidebar .collection__top-bar .facets-summary button:has(.reversed-link)',
              )
              ?.click();
          });
        }
      }

      document.body.classList.add(testInfo.className);

      handleScroll();
      window.addEventListener('scroll', handleScroll, { passive: true });
      window.addEventListener('resize', setGMDStickyTop);

      const config = { childList: true, characterData: true, subtree: true, attributes: true };
      let running = false;
      const observer = new MutationObserver(() => {
        if (running) return;
        ctaTextUpdate();
        setGMDStickyTop();
        running = true;
        setTimeout(() => {
          running = false;
        }, 10);
      });

      const observeRoot =
        document.querySelector('main > section:has(.collection)') ||
        document.querySelector('.shopify-section--main-collection') ||
        document.querySelector('.collection.collection--filters-sidebar')?.closest('section');

      if (observeRoot) {
        observer.observe(observeRoot, config);
      }
    });
  }
})();
